import * as actionTypes from '../actions/actionTypes';

const initialState = {
    error: null,
    token: localStorage.getItem('token'),
    conversationId: null,
    caseId: null,
    status: null,
    agreement_type: null,
    kind_of_claim: null,
    language: null,
    claimant_company_incorporation_location: null,
    claimant_email_address: null,
    claimant_made_loan_as: null,
    claimant_registered_address: null,
    agreement_oral_or_written: null,
    respondent_email_address: null,
    respondent_incorporation_company_location: null,
    respondent_person_or_company: null,
    respondent_telephone: null,
    dater_entering: null,
    interest_or_not: null,
    claimant_telephone: null,
    total_outstanding_loan: null,
    loan_payments: null,
    repayment_method: null,
    repayment_of_loan: null,
    the_written_clause_amount_of_loan: null,
    the_written_clause_rate_of_interest: null,
    total_amount_of_loan: null,
    written_clause_term_of_repayment: null,
    did_respondent_make_other_payment: null,
    repeated_request: null,
    resolve_by: null,
    claimant_name: null,
    claimant_hkid: null,
    claimant_registered_address: null,
    claimant_address: null,
    respondent_name: null,
    respondent_hkid: null,
    respondent_registered_address: null,
    respondent_address: null,
    respondent_docs: [],
    arbitrator_docs: [],
    claimant_docs: [],
    claimant_steps_completed: {},
    respondent_steps_completed: {},
    finished: null,
    claimantUniqueId: null,
    respondentUniqueId: null,
    userType: null,
    loading: null,
    claimant_newAccount: null,
    respondent_newAccount: null,
    claimantOfferStatus: null,
    claimantOffer: null,
    respondentOfferStatus: null,
    respondentOffer: null,
    acceptedOffer: null,
    claimantPayment:null,
    respondentPayment:null,
    award:null,
    claimantArbitratorName:null,
    respondentArbitratorName:null,
    caseData: null,
    scheduleMeetingFail: null,
};

const caseInformationReducer = (state = initialState, action) => {
    // console.log('%$!@#action caseInformationReducer action: '+JSON.stringify(action))
    switch (action.type) {
        case actionTypes.CASEINFO_SUCCESS:
            // console.log('action caseinfo_success:'+JSON.stringify(action));
            return {
                ...state,
                conversationId: action.conversationId,
                caseId: action.caseId,
                status: action.status,
                agreement_type: action.agreement_type,
                kind_of_claim: action.kind_of_claim,
                language: action.language,
                claimant_company_incorporation_location: action.claimant_company_incorporation_location,
                claimant_email_address: action.claimant_email_address,
                claimant_made_loan_as: action.claimant_made_loan_as,
                claimant_registered_address: action.claimant_registered_address,
                agreement_oral_or_written: action.agreement_oral_or_written,
                respondent_email_address: action.respondent_email_address,
                respondent_incorporation_company_location: action.respondent_incorporation_company_location,
                respondent_person_or_company: action.respondent_person_or_company,
                respondent_telephone: action.respondent_telephone,
                dater_entering: action.dater_entering,
                interest_or_not: action.interest_or_not,
                claimant_telephone: action.claimant_telephone,
                total_outstanding_loan: action.total_outstanding_loan,
                loan_payments: action.loan_payments,
                repayment_method: action.repayment_method,
                repayment_of_loan: action.repayment_of_loan,
                the_written_clause_amount_of_loan: action.the_written_clause_amount_of_loan,
                the_written_clause_rate_of_interest: action.the_written_clause_rate_of_interest,
                total_amount_of_loan: action.total_amount_of_loan,
                written_clause_term_of_repayment: action.written_clause_term_of_repayment,
                did_respondent_make_other_payment: action.did_respondent_make_other_payment,
                repeated_request: action.repeated_request,
                resolve_by: action.resolve_by,
                claimant_name: action.claimant_name,
                claimant_hkid: action.claimant_hkid,
                claimant_address: action.claimant_address,
                respondent_name: action.respondent_name,
                respondent_hkid: action.respondent_hkid,
                respondent_registered_address: action.respondent_registered_address,
                respondent_address: action.respondent_address,
                respondent_docs: action.respondent_docs || [],
                arbitrator_docs: action.arbitrator_docs || [],
                claimant_docs: action.claimant_docs || [],
                claimant_steps_completed: action.claimant_steps_completed,
                respondent_steps_completed: action.respondent_steps_completed,
                finished: action.finished,
                claimantUniqueId: action.claimantUniqueId,
                respondentUniqueId: action.respondentUniqueId,
                loading: false,
                claimant_newAccount: action.claimant_newAccount,
                respondent_newAccount: action.respondent_newAccount,
                claimantOfferStatus: action.claimantOfferStatus,
                claimantOffer: action.claimantOffer,
                respondentOfferStatus: action.respondentOfferStatus,
                respondentOffer: action.respondentOffer,
                acceptedOffer: action.acceptedOffer,
                claimantPayment: action.claimantPayment,
                respondentPayment: action.respondentPayment,
                award: action.award,
                claimantArbitratorName: action.claimantArbitratorName,
                respondentArbitratorName: action.respondentArbitratorName,
                caseData:action.caseData
            };
        case actionTypes.CASEINFO_FAIL:
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        case actionTypes.SET_CASE_INFORMATION_USERTYPE:
            return {
                ...state,
                userType: action.userType,
            };
        case actionTypes.CASEINFO_START:
            return {
                ...state,
                loading: true,
                claimant_newAccount: null,
                respondent_newAccount: null,
            };
        case actionTypes.SET_ADD_OFFER_ERROR:
            return{
                ...state,
                AddOfferError: action.AddOfferError
            };
        case actionTypes.SET_ADD_OFFER_NOERROR:
            return{
                ...state,
                AddOfferError: action.AddOfferError
            };
        case actionTypes.SET_ADD_OFFER_ACCEPTED:
            return{
                ...state,
                AddOfferAccepted:action.AddOfferAccepted,
                AddOfferError: action.AddOfferError
        }
        case actionTypes.SCHEDULE_MEETING_FAIL:
            return{
                ...state,
                scheduleMeetingFail:true
        }
        case actionTypes.SCHEDULE_MEETING_TRUE:
            return{
                ...state,
                scheduleMeetingFail:false
        }
        
        default:
            return state;
    }
};

export default caseInformationReducer;